import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Contest } from 'src/app/models/contest';
import { Question } from 'src/app/models/question';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { ContestService } from 'src/app/services/contest.service';
import { ToolsService } from 'src/app/services/tools.service';
import { ButtonsModalComponent } from '../buttons-modal/buttons-modal.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @Input() showBack: boolean = false;
  @Input() contest?: Contest;
  @Input() role?: number;
  @Input() pqrsMode: boolean = false;
  @Input() isUpdateDataMode: boolean = false;

  @Output() loginSuccess = new EventEmitter<void>();

  @Output() onContinue: EventEmitter<any> = new EventEmitter<any>();
  @Output() onShowBills: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBack: EventEmitter<any> = new EventEmitter<any>();

  privacyPolicyAccepted: boolean = false;
  termsAccepted: boolean = false;
  loginQuestions: Array<Question> = [];
  loading: boolean = false;
  captcha: string = '';
  user: any;
  lastContests: Array<Contest> = [];
  activeContests: Array<Contest> = [];

  isDocumentValid: boolean = false;

  autoLoginExecuted = false;

  constructor(
    public configService: ConfigService,
    private authService: AuthService,
    private toolService: ToolsService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private modalCtrl: ModalController,
    private route: ActivatedRoute,
    public contestService: ContestService,
    private router: Router
  ) {
    this.route.queryParams.subscribe(() => {});

    this.user = null;
    this.loadQuestions();
  }

  ngOnInit() {
    this.validateCaptcha();

    if (this.toolService.start) {
      const role = this.toolService.role;

      this.router.navigate([], {
        queryParams: {
          role: role,
          start: true,
        },
        queryParamsHandling: 'merge',
      });
    }

    this.route.queryParams.subscribe((params) => {
      const start = params['start'];
      const role = params['role'];

      if (start === 'true' && role) {
        this.autoLoginExecuted = false;
      }

      if (this.autoLoginExecuted) return;

      if (start === 'true' && role) {
        this.autoLoginExecuted = true;

        const user = sessionStorage.getItem('user');
        if (!user) return;

        try {
          const parsedUser = JSON.parse(user);

          const document = parsedUser.document;
          const document_type = parsedUser.document_type;

          if (!document || !document_type) return;

          this.loginQuestions.forEach((question) => {
            if (question.id === 'document-type') {
              question.formControl.setValue(document_type);
            }

            if (question.id === 'document') {
              question.formControl.setValue(document);
            }
          });

          this.continue();

        } catch (error) {
          console.error('Error parseando user', error);
        }
      }
    });
  }

  async getButtons() {
    await this.authService.getButtonsRoles().subscribe((response) => {
      if (response.length > 0) {
        this.openModalButtons(response);
      }
    });
  }

  async openModalButtons(buttons: any) {
    const modal = await this.modalCtrl.create({
      component: ButtonsModalComponent,
      componentProps: {
        buttons,
      },
    });
    await modal.present();
  }
  loadQuestions() {
    const documentTypeOptions = this.configService.getUserDocumentTypeOptions();
    const defaultDocumentType = this.user
      ? this.user.document_type
      : this.configService.getDefaultUserDocumentType();

    this.loginQuestions = [
      {
        id: 'document-type',
        label: 'Tipo de documento *',
        type: 'select',
        defaultValue: defaultDocumentType,
        incremental_info: false,
        options: documentTypeOptions,
        formControl: new FormControl(defaultDocumentType, [Validators.required]),
      },
      {
        id: 'document',
        label: 'Documento *',
        type: 'text',
        incremental_info: false,
        formControl: new FormControl(this.user ? this.user.document : '', [
          Validators.required,
        ]),
      },
    ];

    if (this.user) {
      this.privacyPolicyAccepted = true;
      this.continue();
    }

  }

  // validateCaptcha(): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     this.recaptchaV3Service.execute('login').subscribe((captcha: string) => {
  //       // console.debug(`Captcha token [${token}] generated`);
  //       resolve(captcha);
  //     });
  //   });
  // }

  validateCaptcha(action = 'login') {
    if (this.configService.mall?.captcha_token) {
      this.recaptchaV3Service.execute(action).subscribe((token: string) => {
        this.captcha = token;
      });
    }
  }

  async continue() {
    // Validate form
    let valid: boolean = true;
    this.loginQuestions.forEach((question) => {
      if (!question.formControl.valid) {
        question.formControl.markAsTouched();
        valid = false;
      }
    });
    if (!valid) return;
    this.loading = true;

    // Validate captcha
    // let captchaToken = await this.validateCaptcha();

    let document_type = this.toolService.getValueFromLoginQuestion(
      'document-type',
      this.loginQuestions
    );
    let document = this.toolService.getValueFromLoginQuestion(
      'document',
      this.loginQuestions
    );
    this.validateCaptcha();

    this.authService.login(document_type, document, this.captcha).subscribe({
      next: (lite_token: { refresh_token: string; access_token: string }) => {
        this.authService.setToken(lite_token.refresh_token);
        this.authService.saveLiteToken(lite_token.access_token);

        this.authService.saveUserAuth(document, document_type);
        this.configService.document_number = document;
        this.configService.document_type = document_type;
        this.configService.saveUserLoginData(document_type, document);
        this.loginSuccess.emit();

        if (this.pqrsMode) {

          const pqrRegistration = localStorage.getItem('pqr_registration') === 'true';

          // For pqr registration false
          if (!pqrRegistration) {

            this.configService.getFlowById().subscribe({
              next: (data) => {
                this.loading = false;

                const isEmpty = Array.isArray(data) && data.length === 0;
                localStorage.setItem('pqr_user_registered', String(isEmpty));

                this.router.navigate(['client-pqr'], {
                  queryParams: { pqrs: 1 }
                });
              },
              error: (err) => {
                this.loading = false;
                console.error(err);
              }
            });

            return;
          }

          // For pqr registration true
          this.configService.getFlowById().subscribe({
            next: (data) => {
              this.loading = false;

              const isEmpty = Array.isArray(data) && data.length === 0;

              if (isEmpty) {
                this.router.navigate(['client-pqr'], {
                  queryParams: { pqrs: 1 }
                });
              } else {
                this.onContinue.emit({
                  next: 'progressive-profile',
                  data: {
                    document_type,
                    document,
                    flow: data,
                    pqrs: true
                  },
                });
              }
            },
            error: (err) => {
              this.loading = false;
              console.error(err);
            }
          });

          return;
        }

        this.configService.getFlowById().subscribe({
          next: (data) => {
            this.loading = false;

            const isEmpty = Array.isArray(data) && data.length === 0;
            const nextComponent = isEmpty
              ? 'upload-bills'
              : 'progressive-profile';

            // if (nextComponent == 'upload-bills') {
            //   this.getButtons();
            // }
            //this.getButtons();
            this.onContinue.emit({
              next: nextComponent,
              data: {
                document_type,
                document,
                flow: data
              },
            });

            this.autoLoginExecuted = false
          },
          error: (err) => {
            this.loading = false;
            if (err.status == 404) {
              console.debug('No user, redirect to signup');
              this.onContinue.emit({
                next: 'signup',
                data: { document_type, document },
              });
            } else if (err.status == 400) {
              console.error('Login error', err);
              if (err.error.error == 'Invalid captcha') {
                this.toolService.presentErrorToast(
                  'Captcha inválido, intenta de nuevo'
                );
              } else {
                this.toolService.presentErrorToast(
                  'El tipo de documento no coincide con el número de documento'
                );
              }
            } else {
              console.error('Login error', err);
              this.toolService.presentErrorToast(
                'Ocurrió un error inesperado, intenta de nuevo más tarde'
              );
            }
          },
        });
      },
      error: (error) => {
        console.error('Error al loguearse:', error);
      },
    });
  }

  goShowBills() {
    this.onShowBills.emit();
  }

  goBack() {
    this.onBack.emit();
  }

  validateDocument() {
    const documentValue = this.toolService.getValueFromLoginQuestion('document', this.loginQuestions);
    this.isDocumentValid = !!documentValue && documentValue.length >= 6 && documentValue.length <= 12;
  }

  setLoginValues(document_type: string, document: string) {
    this.loginQuestions.forEach((question) => {
      if (question.id === 'document-type') {
        question.formControl.setValue(document_type);
      }

      if (question.id === 'document') {
        question.formControl.setValue(document);
      }
    });
  }
}
